addEventListener('pagehide', () => {
    sessionStorage.setItem('previous', `${location.origin}${location.pathname}`);
    sessionStorage.removeItem('reloaded');
});
addEventListener('pageshow', () => {
    if (sessionStorage.previous === `${location.origin}${location.pathname}`) {
        sessionStorage.setItem('reloaded', 'reloaded');
    }
});
